import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userApi } from "./Data/services/userApi";

const GlobalApiRefetcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    // Fetch immediately
    dispatch(userApi.endpoints.getBusinessProfileList.initiate({}));

    // Poll every 5 minutes
    const interval = setInterval(() => {
      dispatch(userApi.endpoints.getBusinessProfileList.initiate({}, { forceRefetch: true }));
    }, 300000);

    return () => clearInterval(interval);
  }, [dispatch]);

  return null;
};

export default GlobalApiRefetcher;
